import { WebPlugin } from '@capacitor/core';
import { getPerformance, trace as createTrace } from 'firebase/performance';
export class FirebasePerformanceWeb extends WebPlugin {
    constructor() {
        super(...arguments);
        this.traces = {};
    }
    async startTrace(options) {
        const perf = getPerformance();
        const trace = createTrace(perf, options.traceName);
        trace.start();
        this.traces[options.traceName] = trace;
    }
    async stopTrace(options) {
        const trace = this.traces[options.traceName];
        if (!trace) {
            return;
        }
        trace.stop();
    }
    async incrementMetric(options) {
        const trace = this.traces[options.traceName];
        if (!trace) {
            return;
        }
        trace.incrementMetric(options.metricName, options.incrementBy);
    }
    async setPerformanceCollectionEnabled(options) {
        const perf = getPerformance();
        perf.instrumentationEnabled = options.enabled;
        perf.dataCollectionEnabled = options.enabled;
    }
    async isPerformanceCollectionEnabled() {
        const perf = getPerformance();
        const result = {
            enabled: perf.instrumentationEnabled || perf.dataCollectionEnabled,
        };
        return result;
    }
}
//# sourceMappingURL=web.js.map